export default __webpack_public_path__ + "fef5e79fce2da4d9b36f4249082e50ae.svg";